import type { JSX } from 'react';

import { TranslatePlural } from '@change-corgi/core/react/i18n';
import { Text } from '@change-corgi/design-system/typography';

import { usePetitionSignatureCount } from '../../../hooks/petitionStats';

export function SignatureStatsVictoryContainer(): JSX.Element {
	const { signatureCount } = usePetitionSignatureCount();

	return (
		<Text size="small">
			<TranslatePlural
				value="fe.pages.petition_show.num_supporters_victory"
				replacements={{
					num_sigs: signatureCount.displayedLocalized,
				}}
				count={signatureCount.displayed}
			/>
		</Text>
	);
}
